<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          class="demo-ruleForm"
        >
          <div class="border_space">
            <p>拣货设置</p>
            <hr />
            <div style="height: 51px; line-height: 51px">
              异常提示:大于等于<el-input
                v-model="form.yc_range"
                style="width: 20%"
                prop="yc_range"
              ></el-input>
              %或者大于等于<el-input
                v-model="form.yc_num"
                type="number"
                style="width: 20%"
                prop="yc_num"
              ></el-input>
              件商品有异常时，提示<el-input
                v-model="form.alert_txt"
                type=""
                style="width: 20%"
                prop="alert_txt"
              ></el-input>
            </div>
          </div>
          <div class="border_space">
            <p>囤货上架配置</p>
            <hr />
            <div style="height: 51px; line-height: 51px">
              上架时扫描商品数量配置： 扫描商品大于等于
              <!--todo: 待更换字段-->
              <el-input
                v-model="form.stock_scan_rate"
                style="width: 20%"
                prop="stock_scan_rate"
              ></el-input>
              %容器内所需上架商品，允许扫描仓位将容器上架。
            </div>
          </div>
          <div class="border_space">
            <el-row class="">
              <el-col
                :span="12"
                style="padding-top: 31px; border-right: 2px solid #ccc"
              >
                <p>拣货任务花名设置</p>
                <hr />
                <el-form-item label="单个波次:" prop="one_wave_picking">
                  <el-input
                    v-model="form.one_wave_picking"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="单件汇总:" prop="one_wave_picking_summary">
                  <el-input
                    v-model="form.one_wave_picking_summary"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="多件多波:" prop="many_num_wave_picking">
                  <el-input
                    v-model="form.many_num_wave_picking"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="多件少波:" prop="less_num_wave_picking">
                  <el-input
                    v-model="form.less_num_wave_picking"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="质检汇总:" prop="quality_summary">
                  <el-input
                    v-model="form.quality_summary"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="改标汇总:" prop="label_summary">
                  <el-input
                    v-model="form.label_summary"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="padding-top: 31px">
                <p style="margin-left: 15px">分播设置</p>
                <hr />
                <el-form-item
                  label="波次粗分单格口波次数:"
                  prop="rough_wave_num"
                  style="margin-left: 15px"
                >
                  <el-input-number
                    v-model="form.rough_wave_num"
                    :min="2"
                    type=""
                  ></el-input-number>
                </el-form-item>
                <hr />
                <div class="picking-task-path">
                  <p style="margin-left: 15px">pda拣货任务路径配置</p>
                  <div class="picking-task-path-wrap">
                    <Draggable
                      v-model="pdaPickingTaskPaths"
                      group="people"
                      class="picking-task-path-list"
                      @start="drag = true"
                      @end="drag = false"
                    >
                      <el-button
                        v-for="name in pdaPickingTaskPaths"
                        :key="name"
                        class="drag-item"
                      >
                        {{ name }}
                      </el-button>
                    </Draggable>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="submit-wrap">
          <el-button class="on-submit" type="primary" @click="onSubmit">
            保存
          </el-button>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import Global_ from "../../components/Global";
import HeaderTabs from "./components/HeaderTabs";

export default {
  components: { HeaderTabs, Draggable },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {},
      loading: false,
      tableLoading: false,
      url: "/erp/AdminSetting/pdaSetting",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
      stock_scan_rate: null,
      pdaPickingTaskPaths: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        const { code, msg, data } = res.data;
        if (code !== 200) {
          this.$message.error(msg);
        } else {
          this.form = data.value;
          this.pdaPickingTaskPaths = data.pda_pick_route;
        }
      });
    },
    onSubmit() {
      this.loading = true;
      const params = {
        pick_route: this.pdaPickingTaskPaths,
        ...this.filteredForm,
      };
      this.$http.post(this.url, params).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("操作成功");
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
.border_space {
  border-radius: 2px;
  margin: 10px 0 50px 0;
}
.picking-task-path-list {
  width: 600px;
  height: 140px;
  flex-wrap: wrap;
  display: flex;
  justify-content: flex-start;
  align-content: space-between;
}
.drag-item {
  margin-left: 10px;
}
.picking-task-submit {
  margin-top: 16px;
}
.submit-wrap {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/PdaSetting.vue